{
  "watchVideo": "Watch Video",
  "listen": "Listen",
  "openIn": "Open In",
  "notFoundTitle": "Sermon Not Found",
  "notFoundDescription": "We couldn't find that sermon."
}
